<template>
   <AccountProfileField
      v-if="birthday"
      :title="field.label"
      :details="birthday"
      :fieldNotice="field.fieldNotice"
      data-cy="profile-date-of-birth"
   />
</template>
<script setup lang="ts">
import type { AccountProfileField } from "@/components/account/accountTypes";
import { useUserStore } from "@/stores/userStore";
import { useLocaleStore } from "@/stores/localeStore";

const userStore = useUserStore();
const localeStore = useLocaleStore();

// Props
// ------------------------------------
const props = defineProps<{
   field: AccountProfileField;
}>();

// Computed
// ------------------------------------
const birthday = computed(() => {
   if (!userStore.user.birthday) return null;

   const date = new Date(userStore.user.birthday);
   const formatter = new Intl.DateTimeFormat(localeStore.currentLocale.id, {
      day: "numeric",
      month: "long",
      year: "numeric",
      timeZone: "UTC", // keeps the date in UTC format preventing the date from being converted to the local timezone
   });
   return formatter.format(date);
});
</script>
